import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { clamp, lerp } from '@mockly/animation-utils';

gsap.registerPlugin(SplitText);

class TextReveal extends HTMLElement {
  #targetProgress = 0;
  #container = null;
  #progress = 0;
  #rafLoop = null;
  #splitText = null;

  constructor() {
    super();

    this.animate = this.animate.bind(this);
  }

  animate() {
    const rect = this.#container.getBoundingClientRect()

    const offsetY = -1 * (rect.top - window.innerHeight)
    
    this.#targetProgress = clamp(offsetY / window.innerHeight, 0, 1)

    if ((this.#progress > 0 || this.#progress < 1) && !(this.#progress === this.#targetProgress)) {
      this.#progress = lerp(this.#progress, this.#targetProgress, 0.065)
      this.style.setProperty('--progress', this.#progress)
      this.style.setProperty('--opacity-progress', (this.#progress - 0.5) * 2)
    }

    this.#rafLoop = requestAnimationFrame(this.animate)
  }

  setupWordReveal() {
    if (!this.#container) return

    this.#splitText = SplitText.create(this.#container, {
      type: 'words',
      wordsClass: 'text-reveal__word'
    })

    const wordCount = this.#splitText.words?.length ?? 0

    this.#splitText.words?.forEach((word, index) => {
      const wordProgress = index / wordCount
      
      word.style.setProperty('--word-progress', wordProgress)
    })
  }

  connectedCallback() {
    this.#container = this;

    this.setupWordReveal();

    this.#rafLoop = requestAnimationFrame(this.animate)
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.#rafLoop);
  }
}

if (!customElements.get('text-reveal')) {
  customElements.define('text-reveal', TextReveal);
}